@let nameShort =
  chat().nombre_contacto.length > 0 ? (chat().nombre_contacto | slice: 0 : 2 | uppercase) : 'X';

<div class="flex h-full min-h-0 flex-col overflow-hidden">
  <header
    class="flex items-center justify-between gap-3 border-b border-[#e5e7eb] bg-[#f0f2f5] px-4 py-2"
  >
    <div class="flex items-center gap-3">
      <button
        type="button"
        class="inline-flex items-center justify-center rounded-full p-2 text-slate-600 transition hover:bg-slate-100 lg:hidden"
        aria-label="Volver a los chats"
        (click)="onVolver()"
      >
        <i class="bi bi-arrow-left text-lg"></i>
      </button>
      @if (chat().profilePictureUrl) {
        <img
          class="h-10 w-10 shrink-0 rounded-full object-cover"
          [src]="chat().profilePictureUrl"
          [alt]="chat().nombre_contacto"
        />
      } @else {
        <div
          class="flex h-10 w-10 shrink-0 items-center justify-center rounded-full text-sm font-semibold"
          [class]="getColor()"
        >
          {{ nameShort }}
        </div>
      }
      <div>
        <div class="flex flex-wrap items-center gap-2">
          <h2 class="text-sm font-semibold text-slate-900 sm:text-base">
            {{ chat().nombre_contacto || 'Contacto desconocido' }}
          </h2>
          @if (presenciaChat()?.remoteJid === chat().remoteJid && presenciaChat()?.presencia === 'composing') {
            <span
              class="rounded-full bg-amber-100 px-2 py-0.5 text-[11px] font-semibold text-amber-700 animate-pulse"
              >escribiendo...</span
            >
          }
        </div>
        <p class="text-xs text-slate-500">{{ chat().numero_contacto }}</p>
      </div>
    </div>
    <div class="flex items-center gap-1 text-slate-500">
      <button class="rounded-full p-2 transition hover:bg-slate-100" aria-label="Favorito">
        ☆
      </button>
      <button class="rounded-full p-2 transition hover:bg-slate-100" aria-label="Archivar">
        ⌂
      </button>
      <button class="rounded-full p-2 transition hover:bg-slate-100" aria-label="Más opciones">
        ⋮
      </button>
    </div>
  </header>

  <section #mensajesContainer class="flex-1 overflow-y-auto px-3 py-2">
    <div class="mx-auto flex max-w-4xl flex-col space-y-1.5">
      @for (mensaje of mensajes(); track $index) {
        @if (hayCambioDeFecha(mensaje)) {
          <div class="flex justify-center py-1 sm:py-1.5">
            <span class="rounded-md bg-[#e1f3fb] px-3 py-1 text-[11px] text-[#54656f]">
              {{ mensaje.fecha | date: 'fullDate' : undefined : 'es-PE' }}
            </span>
          </div>
        }
        <app-chat-message-bubble
          [mensaje]="mensaje"
          [nameShort]="nameShort"
          [nombreContacto]="chat().nombre_contacto"
        />
      }
    </div>
  </section>

  <footer class="sticky bottom-0 border-t border-slate-200 bg-white px-3 py-3 sm:px-4">
    <app-mica-chat-input-mensaje />
  </footer>
</div>
